import { rei } from "@/services/api"
import Custa from '@/entities/Custas/Custa.js'

class CustasService {
  static async getCustas (params = null) {
    if (params == null) {
      return rei.get(`custas`).then(res => res.data)
    }

    let query = []
    params.perPage && query.push('perPage=' + params.perPage)
    params.page && query.push('page=' + params.page)
    typeof params.ativo === 'boolean' && query.push('ativo=' + params.ativo)
    params.vigencia && query.push('vigencia=' + params.vigencia)
    params.tipo && query.push('tipo=' + params.tipo)
    params.ato && query.push('ato=' + params.ato)
    params.uf && query.push('uf=' + params.uf);
    ([0,1].indexOf(params.registro_oficial) !== -1) && query.push('registro_oficial=' + params.registro_oficial)
    params.averbacao && query.push('averbacao=' + params.averbacao)
    params.cartorio_id && query.push('cartorio_id=' + params.cartorio_id);
    ([0,1].indexOf(params.os) !== -1) && query.push('os=' + params.os)
    const custas =  await rei.get(`custas?${query.join('&')}`).then(res => res.data)
    custas.data = custas.data.map((custa) => new Custa(custa))
    return custas
  }

  static storeCustas (custa) {
    custa.uf = custa.uf || "SP"
    return rei.post(`custas`, custa).then(res => res.data)
  }

  static updateCustas (custa, id) {
    return rei.put(`custas/${id}`, custa).then(res => res.data)
  }

  static atualizaAtivo (id) {
    return rei.post(`atualiza-ativo-custa/${id}`)
  }

  static getVigencias () {
    return rei.get(`custas-vigencias`).then(res => res.data)
  }
  
  static getVigenciasByTipo (tipo) {
    return rei.get(`custas-vigencias-by-tipo/${tipo}`).then(res => res.data)
  }

  static getCustaAverbacaoById (id) {
    return rei.post(`custa-averbacao/${id}`).then(res => res.data)
  }

}

export default CustasService
